import { render } from "./CompleteRequestDialog.vue?vue&type=template&id=238323f4"
import script from "./CompleteRequestDialog.vue?vue&type=script&lang=js"
export * from "./CompleteRequestDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__